import { useState, useEffect } from "react";

const GridListViewComponent = ({
  gridView,
  setGridView,
  "data-testid": dataTestId = "grid-list-view-toggle",
}) => {
  const [isDark, setIsDark] = useState(
    document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="hiddenfilterHolder bg-white dark:darkThemeGradiantBg shadow-appShadow px-2 py-1 flex justify-between items-center gap-2 h-9 rounded-md" data-testid={dataTestId}>
      <div
        className="gridViewHolder cursor-pointer"
        onClick={() => setGridView(!gridView)}
        title="Grid View"
        data-testid={`${dataTestId}-grid-button`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M2.08325 5.41634C2.08325 3.84499 2.08325 3.05932 2.57141 2.57116C3.05956 2.08301 3.84524 2.08301 5.41658 2.08301C6.98793 2.08301 7.77361 2.08301 8.26176 2.57116C8.74992 3.05932 8.74992 3.84499 8.74992 5.41634C8.74992 6.98769 8.74992 7.77336 8.26176 8.26152C7.77361 8.74967 6.98793 8.74967 5.41658 8.74967C3.84524 8.74967 3.05956 8.74967 2.57141 8.26152C2.08325 7.77336 2.08325 6.98769 2.08325 5.41634Z"
            stroke={
              !gridView
                ? isDark
                  ? "#FFFFFF"
                  : "#1E2A2C"
                : "#FF8C65"
            } strokeWidth="1.5" />
          <path d="M11.25 14.5833C11.25 13.012 11.25 12.2263 11.7382 11.7382C12.2263 11.25 13.012 11.25 14.5833 11.25C16.1547 11.25 16.9404 11.25 17.4285 11.7382C17.9167 12.2263 17.9167 13.012 17.9167 14.5833C17.9167 16.1547 17.9167 16.9404 17.4285 17.4285C16.9404 17.9167 16.1547 17.9167 14.5833 17.9167C13.012 17.9167 12.2263 17.9167 11.7382 17.4285C11.25 16.9404 11.25 16.1547 11.25 14.5833Z"
            stroke={
              !gridView
                ? isDark
                  ? "#FFFFFF"
                  : "#1E2A2C"
                : "#FF8C65"
            } strokeWidth="1.5" />
          <path d="M2.08325 14.5833C2.08325 13.012 2.08325 12.2263 2.57141 11.7382C3.05956 11.25 3.84524 11.25 5.41658 11.25C6.98793 11.25 7.77361 11.25 8.26176 11.7382C8.74992 12.2263 8.74992 13.012 8.74992 14.5833C8.74992 16.1547 8.74992 16.9404 8.26176 17.4285C7.77361 17.9167 6.98793 17.9167 5.41658 17.9167C3.84524 17.9167 3.05956 17.9167 2.57141 17.4285C2.08325 16.9404 2.08325 16.1547 2.08325 14.5833Z"
            stroke={
              !gridView
                ? isDark
                  ? "#FFFFFF"
                  : "#1E2A2C"
                : "#FF8C65"
            } strokeWidth="1.5" />
          <path d="M11.25 5.41634C11.25 3.84499 11.25 3.05932 11.7382 2.57116C12.2263 2.08301 13.012 2.08301 14.5833 2.08301C16.1547 2.08301 16.9404 2.08301 17.4285 2.57116C17.9167 3.05932 17.9167 3.84499 17.9167 5.41634C17.9167 6.98769 17.9167 7.77336 17.4285 8.26152C16.9404 8.74967 16.1547 8.74967 14.5833 8.74967C13.012 8.74967 12.2263 8.74967 11.7382 8.26152C11.25 7.77336 11.25 6.98769 11.25 5.41634Z"
            stroke={
              !gridView
                ? isDark
                  ? "#FFFFFF"
                  : "#1E2A2C"
                : "#FF8C65"
            } strokeWidth="1.5" />
        </svg>
      </div>
      <div
        className="listViewHolder cursor-pointer"
        onClick={() => setGridView(!gridView)}
        title="List View"
        data-testid={`${dataTestId}-list-button`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M16.6665 4.83301L3.33317 4.83301"
            stroke={
              gridView
                ? isDark
                  ? "#FFFFFF"
                  : "#1E2A2C"
                : "#FF8C65"
            }
            strokeWidth="1.5" strokeLinecap="round" />
          <path d="M16.6667 10L3.33342 10"
            stroke={
              gridView
                ? isDark
                  ? "#FFFFFF"
                  : "#1E2A2C"
                : "#FF8C65"
            } strokeWidth="1.5" strokeLinecap="round" />
          <path d="M16.6665 15.167L3.33317 15.167"
            stroke={
              gridView
                ? isDark
                  ? "#FFFFFF"
                  : "#1E2A2C"
                : "#FF8C65"
            } strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </div>
    </div>
  );
}

export default GridListViewComponent;